import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { roleHome } from '../utils/roleHome';

/**
 * Iter-417 — the root "/" route used to unconditionally Navigate('/login').
 * Combined with ProtectedRoute bouncing role mismatches to "/", that turned
 * every mismatch into a phantom forced-logout for authenticated users.
 * Now: authenticated users land on their role home; only guests go to /login.
 */
const RootRedirect = () => {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={roleHome(user.role)} replace />;
};

export default RootRedirect;
